import React from 'react'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import CheckBox from 'shared/ui/CheckBox/CheckBox'
import { ReactComponent as MessageIcon } from 'assets/icons/message-full.svg'
import { ReactComponent as GraduateIcon } from 'assets/icons/student-full.svg'
import { ReactComponent as PeopleIcon } from 'assets/icons/parents.svg'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'
import s from './StepSendMessageOne.module.scss'

const SendMessageStep = ({
	prependContent = null,
	messageFooter = null,
	hideRemoveStudent = false,
	visibleStudents = [],
	hiddenStudentsCount,
	showAllStudents,
	toggleShowAllStudents,
	visibleParents = [],
	hiddenParentsCount,
	showAllParents,
	toggleShowAllParents,
	removeStudent,
	addParents,
	setAddParents,
	messageText,
	setMessageText,
	insertStudentName,
	insertParentName,
}) => {
	const toggleAddParents = () => setAddParents(prev => !prev)

	return (
		<div className={s.root}>
			{prependContent}
			<div className={s.block}>
				<div className={s.rowBetween}>
					<div className={s.subtitle}>
						<GraduateIcon className={s.subtitle__icon} aria-hidden />
						Selected Students
					</div>
					<label className={s.checkboxRow}>
						<CheckBox isSelected={addParents} onToggle={toggleAddParents} />
						<span>Add Parents too</span>
					</label>
				</div>
				<div className={s.chipsArea}>
					{visibleStudents.length === 0 ? (
						<span className={s.pillEmpty}>—</span>
					) : (
						<>
							{visibleStudents.map(st => {
								const id = st.id ?? st.studentId ?? st.student_id
								const name = st.name ?? 'Unknown'
								return (
									<span key={id} className={s.pill}>
										<span className={s.pill__avatar}>
											<InitialAvatar
												name={name}
												size={24}
												avatarKey={st.avatarKey}
												avatarSource={st.avatarSource}
												photoUrl={st.photoUrl}
											/>
										</span>
										<span className={s.pill__text}>{name}</span>
										{!hideRemoveStudent ? (
											<button
												type="button"
												className={s.pill__remove}
												onClick={() => removeStudent(id)}
												aria-label={`Remove ${name}`}
											>
												<CrossIcon />
											</button>
										) : null}
									</span>
								)
							})}
							{hiddenStudentsCount > 0 && (
								<button
									type="button"
									className={s.pillMore}
									onClick={toggleShowAllStudents}
								>
									{showAllStudents ? 'Hide' : `+${hiddenStudentsCount}`}
								</button>
							)}
						</>
					)}
				</div>
			</div>

			{addParents && (
				<div className={s.block}>
					<div className={s.subtitle}>
						<PeopleIcon className={s.subtitle__icon} aria-hidden />
						Selected Parents
					</div>
					<div className={s.chipsArea}>
						{visibleParents.length === 0 ? (
							<span className={s.pillEmpty}>—</span>
						) : (
							<>
								{visibleParents.map(p => (
									<span key={p.id ?? p.name} className={s.pill}>
										<span className={s.pill__avatar}>
											<InitialAvatar name={p.name} size={24} />
										</span>
										<span className={s.pill__text}>{p.name}</span>
									</span>
								))}
								{hiddenParentsCount > 0 && (
									<button
										type="button"
										className={s.pillMore}
										onClick={toggleShowAllParents}
									>
										{showAllParents ? 'Hide' : `+${hiddenParentsCount}`}
									</button>
								)}
							</>
						)}
					</div>
				</div>
			)}

			<div className={`${s.block} ${s.messageBlock}`}>
				<div className={s.title}>
					<MessageIcon className={s.title__icon} aria-hidden />
					Message
				</div>
				<div className={s.textareaWrap}>
					<textarea
						className={s.textarea}
						value={messageText}
						onChange={e => setMessageText(e.target.value)}
						placeholder="Type your message..."
					/>
					<div className={s.placeholderButtons}>
						<button
							type="button"
							className={s.addPlaceholder}
							onClick={insertStudentName}
						>
							+ Add Student's Name
						</button>
						<button
							type="button"
							className={s.addPlaceholder}
							onClick={insertParentName}
						>
							+ Add Parent's Name
						</button>
					</div>
				</div>
				{messageFooter}
			</div>
		</div>
	)
}

export default SendMessageStep
